import React from "react";

import { ActivityStatusBadge } from "./activity_status_badge";
import css from "./audit_role_status.module.scss";
import { AuditRoleStatusBadge } from "./audit_role_status_badge";

type AuditRoleStatusProps = {
  role: { state: string; workflow_state: string };
  className?: string;
};

export const AuditRoleStatus = ({ role, className }: AuditRoleStatusProps): JSX.Element => (
  <div className={css.root}>
    {(role.state === "draft" || role.state === "complete") && <ActivityStatusBadge status={role.state} />}
    <AuditRoleStatusBadge status={role.workflow_state} className={className} />
  </div>
);
